import React from 'react';

import { Icon } from '../../icon';
import { IconProps } from '../../icon/types';

export const ArrowLittleDownIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.29571 9.43825C7.48307 9.252 7.73652 9.14746 8.00071 9.14746C8.26489 9.14746 8.51834 9.252 8.70571 9.43825L12.2957 12.9783L15.8357 9.43825C16.0231 9.252 16.2765 9.14746 16.5407 9.14746C16.8049 9.14746 17.0583 9.252 17.2457 9.43825C17.3394 9.53122 17.4138 9.64182 17.4646 9.76368C17.5154 9.88554 17.5415 10.0162 17.5415 10.1483C17.5415 10.2803 17.5154 10.411 17.4646 10.5328C17.4138 10.6547 17.3394 10.7653 17.2457 10.8583L13.0057 15.0983C12.9127 15.192 12.8021 15.2664 12.6803 15.3171C12.5584 15.3679 12.4277 15.3941 12.2957 15.3941C12.1637 15.3941 12.033 15.3679 11.9111 15.3171C11.7893 15.2664 11.6787 15.192 11.5857 15.0983L7.29571 10.8583C7.20198 10.7653 7.12758 10.6547 7.07681 10.5328C7.02605 10.411 6.99991 10.2803 6.99991 10.1483C6.99991 10.0162 7.02605 9.88553 7.07681 9.76368C7.12758 9.64182 7.20198 9.53122 7.29571 9.43825Z"
      fill="currentColor"
    />
  </Icon>
);
